import React, { useState } from 'react';
import { MessageCircle, Send, X } from 'lucide-react';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      sender: 'bot',
      text: 'أهلاً بك في معمل النخبة! كيف يمكنني مساعدتك اليوم؟',
      options: [
        'الأسئلة الشائعة',
        'استشارة طبيب',
        'فهم نتائج التحاليل',
        'شروط التحاليل'
      ],
    },
  ]);
  const [inputValue, setInputValue] = useState('');

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = async (message) => {
    if (!message) return;

    // إضافة رسالة المستخدم إلى المحادثة
    setMessages(prevMessages => [
      ...prevMessages,
      { sender: 'user', text: message },
    ]);

    // معالجة رد الروبوت بناءً على رسالة المستخدم
    // الخيارات الثابتة يتم الرد عليها مباشرة، أما الاستفسارات الأخرى فترسل للذكاء الاصطناعي
    if (['الأسئلة الشائعة', 'ما هي مواعيد العمل؟', 'هل تقدمون خدمة الزيارة المنزلية؟', 'ما هي طرق الدفع المتاحة؟', 'استشارة طبيب', 'فهم نتائج التحاليل', 'شروط التحاليل', 'العودة للقائمة الرئيسية'].includes(message)) {
      setTimeout(() => {
        let botResponse;
        if (message === 'الأسئلة الشائعة') {
          botResponse = {
            sender: 'bot',
            text: 'إليك بعض الأسئلة الشائعة:',
            options: [
              'ما هي مواعيد العمل؟',
              'هل تقدمون خدمة الزيارة المنزلية؟',
              'ما هي طرق الدفع المتاحة؟',
              'العودة للقائمة الرئيسية'
            ],
          };
        } else if (message === 'ما هي مواعيد العمل؟') {
          botResponse = {
            sender: 'bot',
            text: 'نعمل على مدار الساعة 24/7 لخدمتكم.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'هل تقدمون خدمة الزيارة المنزلية؟') {
          botResponse = {
            sender: 'bot',
            text: 'نعم، نوفر خدمة الزيارة المنزلية لأخذ العينات بكل راحة وسرية.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'ما هي طرق الدفع المتاحة؟') {
          botResponse = {
            sender: 'bot',
            text: 'يمكنكم الدفع نقدًا أو بالبطاقات الائتمانية.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'استشارة طبيب') {
          botResponse = {
            sender: 'bot',
            text: 'لطلب استشارة طبية، يرجى إدخال سؤالك وسيقوم أحد أطبائنا بالرد عليك قريباً.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'فهم نتائج التحاليل') {
          botResponse = {
            sender: 'bot',
            text: 'للحصول على مساعدة في فهم نتائج تحليلك، يرجى إرسال رقم الملف الخاص بك.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'شروط التحاليل') {
          botResponse = {
            sender: 'bot',
            text: 'للحصول على شروط تحليل معين (مثل الصيام)، يرجى كتابة اسم التحليل وسأقدم لك التفاصيل.',
            options: ['العودة للقائمة الرئيسية'],
          };
        } else if (message === 'العودة للقائمة الرئيسية') {
          botResponse = {
            sender: 'bot',
            text: 'أهلاً بك مجدداً! كيف يمكنني مساعدتك؟',
            options: [
              'الأسئلة الشائعة',
              'استشارة طبيب',
              'فهم نتائج التحاليل',
              'شروط التحاليل'
            ],
          };
        }
        setMessages(prevMessages => [...prevMessages, botResponse]);
      }, 500);
    } else {
      // إرسال رسالة المستخدم إلى Gemini API
      setIsLoading(true);
      try {
        const chatHistory = [];
        chatHistory.push({ role: "user", parts: [{ text: `أنت مساعد طبي خبير في معمل تحاليل. أجب على هذا السؤال: ${message}` }] });
        const payload = { contents: chatHistory };
        const apiKey = "AIzaSyBBPC_MGxVMbsJ0HUE0x0LOsDINRCs4viE";
        const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-05-20:generateContent?key=${apiKey}`;

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const result = await response.json();
        if (result.candidates && result.candidates.length > 0 &&
          result.candidates[0].content && result.candidates[0].content.parts &&
          result.candidates[0].content.parts.length > 0) {
          const text = result.candidates[0].content.parts[0].text;
          setMessages(prevMessages => [...prevMessages, { sender: 'bot', text: text, options: ['العودة للقائمة الرئيسية'] }]);
        } else {
          setMessages(prevMessages => [...prevMessages, { sender: 'bot', text: 'عذراً، لم أتمكن من الرد. يرجى المحاولة مرة أخرى.', options: ['العودة للقائمة الرئيسية'] }]);
        }
      } catch (error) {
        console.error('API Error:', error);
        setMessages(prevMessages => [...prevMessages, { sender: 'bot', text: 'عذراً، حدث خطأ أثناء الاتصال. يرجى المحاولة مرة أخرى.', options: ['العودة للقائمة الرئيسية'] }]);
      } finally {
        setIsLoading(false);
      }
    }

    setInputValue('');
  };

  const handleOptionClick = (option) => {
    handleSendMessage(option);
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim()) {
      handleSendMessage(inputValue.trim());
    }
  };

  return (
    <>
      {/* أيقونة الروبوت العائمة */}
      <button
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-colors z-50"
        onClick={toggleChatbot}
      >
        <MessageCircle className="w-8 h-8" />
      </button>

      {/* نافذة الروبوت */}
      <div
        className={`fixed bottom-20 right-6 w-96 h-[550px] bg-white rounded-xl shadow-2xl transition-all duration-300 transform ${
          isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
        } origin-bottom-right z-50 flex flex-col`}
        style={{ direction: 'rtl' }}
      >
        {/* رأس النافذة */}
        <div className="bg-blue-600 text-white p-4 rounded-t-xl flex items-center justify-between">
          <div className="flex items-center space-x-2 rtl:space-x-reverse">
            <h3 className="font-bold text-lg">مساعد معمل النخبة</h3>
          </div>
          <button onClick={toggleChatbot} className="p-1 rounded-full hover:bg-blue-700 transition">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* منطقة الرسائل */}
        <div className="flex-1 p-4 overflow-y-auto space-y-4 text-sm">
          {messages.map((msg, index) => (
            <div key={index} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}>
              <div
                className={`max-w-[80%] p-3 rounded-lg shadow-sm ${
                  msg.sender === 'user'
                    ? 'bg-blue-500 text-white rounded-br-none'
                    : 'bg-gray-100 text-gray-800 rounded-bl-none'
                }`}
              >
                {msg.text}
                {msg.options && (
                  <div className="flex flex-col mt-2 space-y-2">
                    {msg.options.map((option, optIndex) => (
                      <button
                        key={optIndex}
                        onClick={() => handleOptionClick(option)}
                        className="bg-white text-blue-600 px-3 py-2 rounded-full text-xs font-semibold shadow-sm hover:bg-blue-50 transition-colors"
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
          {isLoading && (
            <div className="flex justify-start">
              <div className="max-w-[80%] p-3 rounded-lg shadow-sm bg-gray-100 text-gray-800 rounded-bl-none">
                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* حقل الإدخال */}
        <form onSubmit={handleInputSubmit} className="p-4 border-t border-gray-200">
          <div className="flex items-center bg-gray-100 rounded-full px-4 py-2 shadow-inner">
            <input
              type="text"
              className="flex-1 bg-transparent border-none focus:outline-none placeholder-gray-500 text-sm"
              placeholder="اكتب رسالتك..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              style={{ direction: 'rtl' }}
              disabled={isLoading}
            />
            <button
              type="submit"
              className="bg-blue-600 text-white p-2 rounded-full ml-2 hover:bg-blue-700 transition-colors"
              disabled={isLoading}
            >
              <Send className="w-4 h-4" />
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Chatbot;
